import { Autocomplete, TextField } from "@mui/material";
import type { SupportedCurrency } from "../lib/types";

function normalizeCurrencyInput(value: string) {
  return value.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 3);
}

export function CurrencyCodeAutocomplete({
  label,
  value,
  currencies,
  error = false,
  helperText,
  size,
  required = false,
  onChange,
}: {
  label: string;
  value: string;
  currencies: SupportedCurrency[];
  error?: boolean;
  helperText?: string;
  size?: "small" | "medium";
  required?: boolean;
  onChange: (code: string) => void;
}) {
  const selected = currencies.find((currency) => currency.code === value) || null;

  return (
    <Autocomplete<SupportedCurrency, false, false, true>
      freeSolo
      autoHighlight
      fullWidth
      size={size}
      options={currencies}
      value={selected}
      inputValue={value}
      getOptionLabel={(option) => typeof option === "string" ? option : option.code}
      isOptionEqualToValue={(option, current) => typeof current !== "string" && option.code === current.code}
      onChange={(_, option) => onChange(normalizeCurrencyInput(typeof option === "string" ? option : option?.code || ""))}
      onInputChange={(_, input, reason) => {
        if (reason === "input" || reason === "clear") onChange(normalizeCurrencyInput(input));
      }}
      renderOption={(props, option) => (
        <li {...props} className={`${props.className || ""} currency-code-option`} key={option.code}>
          <span className="currency-icon" aria-hidden="true">{option.symbol}</span>
          <strong>{option.code}</strong>
          <span className="currency-code-option-name">· {option.name}</span>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          label={label}
          required={required}
          helperText={helperText}
        />
      )}
    />
  );
}
